import React, { useEffect, useRef } from 'react';
import Odometer from 'react-odometerjs';
import { useStreak } from '../contexts/StreakContext';
import { useResourceCelebration } from '../contexts/ResourceCelebrationContext';
import useResourceReceiveAnimation from '../hooks/useResourceReceiveAnimation';
import styles from '../styles/StreakDisplay.module.css';
import 'odometer/themes/odometer-theme-default.css';

const StreakDisplay = ({ onClick }) => {
  const { streakData, isLoading } = useStreak();
  const { registerTarget, targetImpactVersions, getPresentedCounterValue } = useResourceCelebration();
  const buttonRef = useRef(null);

  const currentStreak = getPresentedCounterValue('streak', streakData?.currentStreak || 0);
  const impactVersion = targetImpactVersions.streak || 0;
  const isReceivingReward = useResourceReceiveAnimation(impactVersion);

  useEffect(() => {
    return registerTarget('streak', buttonRef.current);
  }, [registerTarget]);

  return (
    <button
      ref={buttonRef}
      type="button"
      className={`${styles.streakButton} ${isReceivingReward ? styles.receivingReward : ''}`}
      onClick={onClick}
      title="La tua serie"
      data-resource-target="streak"
    >
      {isLoading ? (
        <span className={styles.loadingDots} />
      ) : (
        <Odometer
          value={currentStreak}
          format="(.ddd)"
          duration={500}
          className={styles.count}
        />
      )}
      <span className={styles.fireIcon}>🔥</span>
    </button>
  );
};

export default StreakDisplay;
